import ViewProduct from "../../../components/@products/products/ViewProduct";

import { routeTypes } from "../../../hooks/useSystemRoutes";

export default function ProductViewPage() {

    return (
        <ViewProduct 
            routeType={routeTypes.retail}
        />
    )
}       